import { PropsWithChildren, useRef } from "react"
import cn from "classnames"

import { useDidMount } from "utils/customHooks"

export function BottomFixed({ children, className }: PropsWithChildren<{ className?: string }>) {
    const footerRef = useRef<HTMLDivElement>(null)
    useDidMount(() => {
        if (footerRef.current) {
            const { height } = footerRef.current.getBoundingClientRect()
            document.documentElement.style.setProperty(
                "--alter-footer-placeholder-height",
                `${Math.floor(height)}px`
            )
        }
    })
    return (
        <div ref={footerRef} className={cn("bottom-fixed", className)}>
            {children}
        </div>
    )
}
